<label for="{{ id }}" class="radio-field">
  <input
    *ngIf="!fakeControl"
    type="radio"
    name="{{ name }}"
    id="{{ id }}"
    class="radio-element"
    [formControl]="control"
    [value]="value"
    [checked]="control.value === value"
    [readonly]="readonly"
  />

  <input
    *ngIf="fakeControl"
    type="radio"
    name="{{ name }}"
    id="{{ id }}"
    class="radio-element"
    value="any"
    [checked]="checked"
    [readonly]="readonly"
  />

  <div class="radio-field-state-receiver">
    <span class="radio-visual"></span>

    <span class="radio-field-label">{{ label }}</span>
  </div>
</label>
